import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/pkgs-gt-bar.scss';

const TAGLINES = {
  '/packages': 'Your date, your request',
  '/group-trips': 'Fixed dates — book with VisitAllNepal',
  '/shared-rentals': 'Fixed rides, share the cost',
};

/**
 * Sticky Group Departures | Private Tours | Shared Rides bar for booking pages.
 */
export default function PackagesGroupTripsBar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const tagline = TAGLINES[pathname] || '';

  return (
    <nav className="pkgs-gt-tabs-bar" role="navigation" aria-label="Book experiences with VisitAllNepal">
      <div className="container">
        <div className="nav nav-tabs nav-fill pkgs-gt-tabs" role="tablist">
          <NavLink
            to="/group-trips"
            className="nav-item nav-link"
            activeClassName="active"
            exact
            role="tab"
            aria-current={pathname === '/group-trips' ? 'page' : undefined}
          >
            <i className="fas fa-users" aria-hidden="true" />
            <span>Group Departures</span>
          </NavLink>
          <NavLink
            to="/packages"
            className="nav-item nav-link"
            activeClassName="active"
            exact
            role="tab"
            aria-current={pathname === '/packages' ? 'page' : undefined}
          >
            <i className="fas fa-briefcase" aria-hidden="true" />
            <span>{t('Private Tours') || 'Private Tours'}</span>
          </NavLink>
          <NavLink
            to="/shared-rentals"
            className="nav-item nav-link"
            activeClassName="active"
            exact
            role="tab"
            aria-current={pathname === '/shared-rentals' ? 'page' : undefined}
          >
            <i className="fas fa-car" aria-hidden="true" />
            <span>Shared Rides</span>
          </NavLink>
        </div>
        {tagline && !['/group-trips', '/packages'].includes(pathname) && (
          <p className="pkgs-gt-tabs-bar__tagline mb-0" aria-live="polite">
            {tagline}
          </p>
        )}
      </div>
    </nav>
  );
}
